import { Observable } from 'rxjs';
import { ConfigModel } from '../models/low-level/config.model';
import { InjectionToken } from '@angular/core';

export interface OdataConfigInterface {
    getConfig(): Observable<ConfigModel[]>;
}

export const OdataConfigInstanceToken = new InjectionToken<OdataConfigInterface>('OdataConfigInterface');
